import axios from 'axios';
import { config } from '../../config';

class Api {
    constructor(router) {
        console.log('router passed in:', router);
        this.router = router;

        this.api = axios.create({
            baseURL: config.apiBaseUrl,
            withCredentials: true
        });

        this.api.interceptors.response.use(
            response => response,
            error => {
                console.log(error);
                if (error.response && (error.response.status === 400 || error.response.status === 401)) {
                    console.log('auth failed, redirecting back to login');
                    this.router.replace('/login');
                }
                else {
                    console.log('unknown axios error caught:', error);
                    throw error;
                }
            }
        );

        // used when we don't want the interceptors to run (e.g. logging in)
        this.noInercept = axios.create({
            baseURL: config.apiBaseUrl,
            withCredentials: true
        });
    }
    
    async login(passcode) {
        return await this.noInercept.post('auth', { passcode });
    }

    async logout() {
        return await this.api.post('logout', {});
    }

    async getCompanies() {
        return await this.api.get('companies');
    }

    async getCompany(companyId) {
        return await this.api.get(`companies/${companyId}`);
    }

    async getGroups() {
        return await this.api.get('groups');
    }

    async getJustGroups() {
        return await this.api.get('groupsonly');
    }

    async createGroup(groupName, groupNotes, companies) {
        const data = {
            groupName,
            groupNotes,
            companies
        };

        return await this.api.post('groups', data);
    }

    async editGroup(groupId, groupName, groupNotes, companies) {
        const data = {
            groupName,
            groupNotes,
            companies
        };

        return await this.api.put(`groups/${groupId}`, data);
    }

    async deleteGroup(groupId) {
        return await this.api.delete(`groups/${groupId}`);
    }

    async hideCompany(companyId) {
        return await this.api.post(`companies/${companyId}/hidden`, companyId);
    }

    async unhideCompany(companyId) {
        return await this.api.delete(`companies/${companyId}/hidden`, companyId);
    }

    async addCompaniesToGroup(groupId, companies) {
        const data = {
            groupId,
            companies
        };

        return await this.api.post(`groupcompanies`, data);
    }

    async updateCompanyNotes(companyId, notes) {
        const data = { notes };
        return await this.api.put(`companies/${companyId}/notes`, data);
    }

    async migrateCompany(companyId) {
        return await this.api.delete(`companies/${companyId}/nomigrate`, companyId);
    }

    async doNotMigrateCompany(companyId) {
        return await this.api.post(`companies/${companyId}/nomigrate`, companyId);
    }
}

export { Api };
